import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'https://dev.qupplo.se';

function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      const data = await res.json();
      if (data.success) {
        onLogin();
      } else {
        setError(data.message || 'Invalid password');
      }
    } catch (err) {
      setError('Network error');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '4rem auto', textAlign: 'center' }}>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Enter admin password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{ padding: '0.7rem', width: '80%', marginBottom: '1rem' }}
        />
        <br />
        <button type="submit" style={{ padding: '0.7rem 2rem' }}>Login</button>
      </form>
      {error && <div style={{ color: 'red', marginTop: '1rem' }}>{error}</div>}
    </div>
  );
}

function SetList({ onSelectSet, onAddSet }) {
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newSetName, setNewSetName] = useState('');
  const [newSetDesc, setNewSetDesc] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/sets`)
      .then(res => res.json())
      .then(data => { setSets(data.sets || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [onAddSet]);

  const handleAddSet = async (e) => {
    e.preventDefault();
    setError(null);
    if (!newSetName.trim()) { setError('Set name required'); return; }
    const res = await fetch(`${API_URL}/api/admin/set`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ set_name: newSetName, description: newSetDesc })
    });
    const data = await res.json();
    if (data.success) {
      setNewSetName(''); setNewSetDesc('');
      onAddSet(); // trigger reload
    } else {
      setError(data.message || 'Failed to add set');
    }
  };

  const filteredSets = sets.filter(s =>
    (s.set_name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (s.description || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div style={{ maxWidth: 700, margin: '2rem auto', textAlign: 'center' }}>
      <h2>Question Sets / Categories</h2>
      <div style={{ marginBottom: '1.5rem' }}>
        <input
          type="text"
          placeholder="🔍 Search categories..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          style={{ padding: '0.6rem 1rem', width: '80%', maxWidth: 400, borderRadius: 20, border: '1px solid #ccc', fontSize: '1rem' }}
        />
      </div>
      {loading ? <p>Loading...</p> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {filteredSets.length === 0 ? (
            <p style={{ color: '#888' }}>No categories found matching "{searchQuery}"</p>
          ) : (
            filteredSets.map(s => (
              <div
                key={s.set_id}
                onClick={() => onSelectSet(s)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1rem 1.25rem',
                  background: '#fff',
                  border: '1px solid #e0e0e0',
                  borderRadius: 10,
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'transform 0.15s, box-shadow 0.15s'
                }}
              >
                <div>
                  <div style={{ fontWeight: 'bold', fontSize: '1.15rem', color: '#1a73e8', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>{s.set_name}</span>
                    <span style={{ fontSize: '0.8rem', background: '#e8f0fe', color: '#1a73e8', padding: '2px 8px', borderRadius: 12, fontWeight: 'normal' }}>
                      {s.question_count !== undefined ? `${s.question_count} questions` : ''}
                    </span>
                  </div>
                  {s.description && (
                    <div style={{ color: '#555', fontSize: '0.9rem', marginTop: 4 }}>
                      {s.description}
                    </div>
                  )}
                  {s.created_at && (
                    <div style={{ color: '#999', fontSize: '0.75rem', marginTop: 4 }}>
                      Created: {s.created_at.split(' ')[0]}
                    </div>
                  )}
                </div>
                <button
                  onClick={(e) => { e.stopPropagation(); onSelectSet(s); }}
                  style={{
                    padding: '0.5rem 1.2rem',
                    background: '#1a73e8',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 6,
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  Manage →
                </button>
              </div>
            ))
          )}
        </div>
      )}
      <form onSubmit={handleAddSet} style={{ marginTop: '2.5rem', background: '#f8f9fa', padding: '1.5rem', borderRadius: 12, border: '1px solid #e2e8f0' }}>
        <h3>Add New Category / Set</h3>
        <input
          type="text"
          placeholder="Set name (e.g. Djur, Rymden)"
          value={newSetName}
          onChange={e => setNewSetName(e.target.value)}
          style={{ padding: '0.6rem', width: '70%', marginBottom: '0.6rem', borderRadius: 6, border: '1px solid #ccc' }}
        /><br />
        <input
          type="text"
          placeholder="Description (optional)"
          value={newSetDesc}
          onChange={e => setNewSetDesc(e.target.value)}
          style={{ padding: '0.6rem', width: '70%', marginBottom: '0.8rem', borderRadius: 6, border: '1px solid #ccc' }}
        /><br />
        <button type="submit" style={{ padding: '0.6rem 2rem', background: '#34a853', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 'bold', cursor: 'pointer' }}>
          + Add Category
        </button>
      </form>
      {error && <div style={{ color: 'red', marginTop: '1rem' }}>{error}</div>}
    </div>
  );
}

function AltImageUploader({ alt, onChange }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = React.useRef();

  const handleFile = async (file) => {
    setUploading(true); setError(null);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch(`${API_URL}/api/admin/upload_image`, {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        onChange(data.url);
      } else {
        setError(data.message || 'Upload failed');
      }
    } catch (e) {
      setError('Network error');
    }
    setUploading(false);
  };

  const handleUrl = async (url) => {
    setUploading(true); setError(null);
    try {
      const res = await fetch(`${API_URL}/api/admin/upload_image`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image_url: url })
      });
      const data = await res.json();
      if (data.success) {
        onChange(data.url);
      } else {
        setError(data.message || 'Image URL download failed');
      }
    } catch (e) {
      setError('Network error');
    }
    setUploading(false);
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
      return;
    }
    
    // Check if dragging image from another tab or HTML element
    let uri = e.dataTransfer.getData('text/uri-list');
    if (!uri) {
      const html = e.dataTransfer.getData('text/html');
      if (html) {
        const match = html.match(/src=["'](https?:\/\/[^"']+)["']/i);
        if (match) uri = match[1];
      }
    }
    if (!uri) {
      const plain = e.dataTransfer.getData('text/plain');
      if (plain && (plain.startsWith('http://') || plain.startsWith('https://'))) {
        uri = plain.trim();
      }
    }
    
    if (uri) {
      // Split multiple URIs if text/uri-list returned lines
      const firstUrl = uri.split('\n').map(s => s.trim()).find(s => s.startsWith('http'));
      if (firstUrl) {
        handleUrl(firstUrl);
        return;
      }
    }

    setError('Could not extract image file or URL from drop');
  };

  return (
    <div style={{ marginTop: 4 }}>
      <div
        onDrop={handleDrop}
        onDragOver={e => e.preventDefault()}
        style={{ border: '1px dashed #aaa', borderRadius: 4, padding: 6, marginBottom: 4, background: '#fafafa', cursor: 'pointer' }}
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
        title="Click or drag file here to upload"
      >
        {uploading ? 'Uploading...' : 'Drag & drop or click to upload image'}
      </div>
      <input
        type="file"
        accept="image/png, image/jpeg, image/gif, image/svg+xml"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      {error && <div style={{ color: 'red', fontSize: 12 }}>{error}</div>}
      {alt.image && (
        <img src={alt.image.startsWith('http') ? alt.image : `${API_URL}${alt.image}`} alt="alt" style={{ maxWidth: 400, maxHeight: 400, marginTop: 4, borderRadius: 4, border: '1px solid #eee' }} />
      )}
    </div>
  );
}

function AltImageGenButton({ prompt, onGen }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const handleGen = async () => {
    if (!prompt || !prompt.trim()) return;
    setLoading(true); setError(null);
    try {
      const res = await fetch(`${API_URL}/api/admin/generate_image`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt })
      });
      const data = await res.json();
      if (data.success) {
        onGen(data.url);
      } else {
        setError(data.message || 'Generation failed');
      }
    } catch (e) {
      setError('Network error');
    }
    setLoading(false);
  };
  return (
    <span style={{ marginLeft: 6 }}>
      <button type="button" onClick={handleGen} disabled={loading || !prompt || !prompt.trim()} title="Generate image from text">Gen</button>
      {loading && <span style={{ marginLeft: 4, fontSize: 12 }}>Generating...</span>}
      {error && <span style={{ color: 'red', fontSize: 12, marginLeft: 4 }}>{error}</span>}
    </span>
  );
}

function EditableQuestion({ q, onUpdate }) {
  const [editQ, setEditQ] = useState(q);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => { setEditQ(q); setMsg(null); }, [q]);

  const handleAltChange = (i, field, value) => {
    setEditQ(prev => {
      const alts = prev.alts.map((a, idx) => idx === i ? { ...a, [field]: value } : a);
      return { ...prev, alts };
    });
  };

  const handleImageUpload = (i, url) => {
    handleAltChange(i, 'image', url);
  };

  const handleUpdate = async () => {
    setSaving(true); setMsg(null);
    try {
      const res = await fetch(`${API_URL}/api/admin/question/${editQ.question_id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          question_text: editQ.text,
          explanation: editQ.explanation,
          alts: editQ.alts,
          correct_index: editQ.correct_index
        })
      });
      const data = await res.json();
      if (data.success) setMsg('Saved!');
      else setMsg(data.message || 'Error saving');
    } catch (e) {
      setMsg('Network error');
    }
    setSaving(false);
    if (onUpdate) onUpdate();
  };

  return (
    <div style={{ border: '1px solid #ccc', borderRadius: 8, margin: '1rem 0', padding: '1rem' }}>
      <div><b>Q:</b> <input value={editQ.text} onChange={e => setEditQ({ ...editQ, text: e.target.value })} style={{ width: '70%' }} /></div>
      <div><i>Explanation:</i> <input value={editQ.explanation} onChange={e => setEditQ({ ...editQ, explanation: e.target.value })} style={{ width: '60%' }} /></div>
      <ul style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', listStyle: 'none', padding: 0 }}>
        {editQ.alts.map((alt, i) => (
          <li key={i} style={{ margin: '0.5rem', minWidth: 120 }}>
            <div>
              <b>Alt {i+1}:</b> <input value={alt.text} onChange={e => handleAltChange(i, 'text', e.target.value)} style={{ width: '80%' }} />
              <AltImageGenButton prompt={alt.text} onGen={url => handleImageUpload(i, url)} />
            </div>
            <div>
              <span>Image URL:</span> <input value={alt.image || ''} onChange={e => handleAltChange(i, 'image', e.target.value)} style={{ width: '80%' }} />
            </div>
            <AltImageUploader alt={alt} onChange={url => handleImageUpload(i, url)} />
            <div>
              <label>
                <input type="radio" name={`correct_${editQ.question_id}`} checked={editQ.correct_index === i} onChange={() => setEditQ({ ...editQ, correct_index: i })} /> Correct
              </label>
            </div>
          </li>
        ))}
      </ul>
      <button onClick={handleUpdate} disabled={saving} style={{ marginTop: 8, padding: '0.5rem 2rem' }}>Update</button>
      {msg && <span style={{ marginLeft: 10, color: msg === 'Saved!' ? 'green' : 'red' }}>{msg}</span>}
    </div>
  );
}

function AddQuestionForm({ setId, onAdded, setName, setDescription, previousQuestions }) {
  const emptyQ = {
    text: '',
    explanation: '',
    alts: [
      { text: '', image: '' },
      { text: '', image: '' }
    ],
    correct_index: 0
  };
  const [editQ, setEditQ] = useState(emptyQ);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [llmLoading, setLlmLoading] = useState(false);
  const [llmError, setLlmError] = useState(null);

  const handleAltChange = (i, field, value) => {
    setEditQ(prev => {
      const alts = prev.alts.map((a, idx) => idx === i ? { ...a, [field]: value } : a);
      return { ...prev, alts };
    });
  };
  const handleImageUpload = (i, url) => {
    handleAltChange(i, 'image', url);
  };
  const handleAddAlt = () => {
    if (editQ.alts.length < 6) setEditQ(prev => ({ ...prev, alts: [...prev.alts, { text: '', image: '' }] }));
  };
  const handleRemoveAlt = (i) => {
    if (editQ.alts.length > 2) setEditQ(prev => ({ ...prev, alts: prev.alts.filter((_, idx) => idx !== i) }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true); setMsg(null);
    try {
      const res = await fetch(`${API_URL}/api/admin/set/${setId}/add_question`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          question_text: editQ.text,
          explanation: editQ.explanation,
          alts: editQ.alts,
          correct_index: editQ.correct_index
        })
      });
      const data = await res.json();
      if (data.success) {
        setMsg('Added!');
        setEditQ(emptyQ);
        if (onAdded) onAdded();
      } else {
        setMsg(data.message || 'Error adding');
      }
    } catch (e) {
      setMsg('Network error');
    }
    setSaving(false);
  };

  const [genLang, setGenLang] = useState('sv');

  const handleSuggest = async () => {
    setLlmLoading(true); setLlmError(null);
    try {
      const res = await fetch(`${API_URL}/api/admin/generate_question`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          set_id: setId,
          category: setName,
          description: setDescription,
          previous_questions: previousQuestions,
          lang: genLang
        })
      });
      const data = await res.json();
      if (data.success && data.question) {
        setEditQ({
          text: data.question.question_text || '',
          explanation: data.question.explanation || '',
          alts: (data.question.alts || []).map(a => ({ text: a.text || '', image: a.image || '' })),
          correct_index: typeof data.question.correct_index === 'number' ? data.question.correct_index : 0
        });
      } else {
        setLlmError(data.message || 'Failed to generate question');
      }
    } catch (e) {
      setLlmError('Network error');
    }
    setLlmLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ border: '1px solid #ccc', borderRadius: 8, margin: '1rem 0', padding: '1rem', background: '#f9f9f9' }}>
      <div><b>Q:</b> <input value={editQ.text} onChange={e => setEditQ({ ...editQ, text: e.target.value })} style={{ width: '70%' }} required /></div>
      <div><i>Explanation:</i> <input value={editQ.explanation} onChange={e => setEditQ({ ...editQ, explanation: e.target.value })} style={{ width: '60%' }} required /></div>
      <div style={{ margin: '0.5rem 0', display: 'flex', alignItems: 'center', gap: 8 }}>
        <button type="button" onClick={handleSuggest} disabled={llmLoading}>Suggest Question (LLM)</button>
        <select value={genLang} onChange={e => setGenLang(e.target.value)} style={{ padding: '0.2rem 0.4rem', borderRadius: 4 }}>
          <option value="sv">🇸🇪 Swedish (Svenska)</option>
          <option value="en">🇬🇧 English</option>
        </select>
        {llmLoading && <span style={{ fontSize: 12 }}>Generating...</span>}
        {llmError && <span style={{ color: 'red', fontSize: 12 }}>{llmError}</span>}
      </div>
      <ul style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', listStyle: 'none', padding: 0 }}>
        {editQ.alts.map((alt, i) => (
          <li key={i} style={{ margin: '0.5rem', minWidth: 120 }}>
            <div>
              <b>Alt {i+1}:</b> <input value={alt.text} onChange={e => handleAltChange(i, 'text', e.target.value)} style={{ width: '80%' }} required />
              <AltImageGenButton prompt={alt.text} onGen={url => handleImageUpload(i, url)} />
            </div>
            <div>
              <span>Image URL:</span> <input value={alt.image || ''} onChange={e => handleAltChange(i, 'image', e.target.value)} style={{ width: '80%' }} />
            </div>
            <AltImageUploader alt={alt} onChange={url => handleImageUpload(i, url)} />
            <div>
              <label>
                <input type="radio" name="correct_new" checked={editQ.correct_index === i} onChange={() => setEditQ({ ...editQ, correct_index: i })} /> Correct
              </label>
              {editQ.alts.length > 2 && <button type="button" onClick={() => handleRemoveAlt(i)} style={{ marginLeft: 8 }}>Remove</button>}
            </div>
          </li>
        ))}
      </ul>
      {editQ.alts.length < 6 && <button type="button" onClick={handleAddAlt} style={{ margin: '0.5rem' }}>Add Alternative</button>}
      <button type="submit" disabled={saving} style={{ marginTop: 8, padding: '0.5rem 2rem' }}>Add Question</button>
      {msg && <span style={{ marginLeft: 10, color: msg === 'Added!' ? 'green' : 'red' }}>{msg}</span>}
    </form>
  );
}

function SetEditView({ set, onBack }) {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/set/${set.set_id}/questions`)
      .then(res => res.json())
      .then(data => { setQuestions(data.questions || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [set.set_id, reload]);

  return (
    <div style={{ maxWidth: 900, margin: '2rem auto', textAlign: 'center' }}>
      <button onClick={onBack} style={{ marginBottom: '1rem' }}>Back to Sets</button>
      <h2>{set.set_name}</h2>
      <p>{set.description}</p>
      <h3>Questions</h3>
      {loading ? <p>Loading...</p> : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {questions.map((q, idx) => (
            <li key={q.question_id}>
              <EditableQuestion q={q} onUpdate={() => setReload(r => !r)} />
            </li>
          ))}
        </ul>
      )}
      <div style={{ borderTop: '1px solid #ccc', marginTop: '2rem', paddingTop: '1rem' }}>
        <h3>Add New Question</h3>
        <AddQuestionForm setId={set.set_id} setName={set.set_name} setDescription={set.description} previousQuestions={questions} onAdded={() => setReload(r => !r)} />
      </div>
    </div>
  );
}

function AdminDashboard() {
  const [selectedSet, setSelectedSet] = useState(null);
  const [reloadSets, setReloadSets] = useState(false);

  if (selectedSet) {
    return <SetEditView set={selectedSet} onBack={() => setSelectedSet(null)} />;
  }
  return <SetList onSelectSet={setSelectedSet} onAddSet={() => setReloadSets(!reloadSets)} />;
}

function AdminApp() {
  const [loggedIn, setLoggedIn] = useState(false);

  return (
    <Routes>
      <Route path="/" element={loggedIn ? <AdminDashboard /> : <Login onLogin={() => setLoggedIn(true)} />} />
      {/* Add more admin routes here as needed */}
    </Routes>
  );
}

export default AdminApp; 